import { render, staticRenderFns } from "./PedidosTabelaItemsPecas.vue?vue&type=template&id=263d2baf&"
import script from "./PedidosTabelaItemsPecas.vue?vue&type=script&lang=ts&"
export * from "./PedidosTabelaItemsPecas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSimpleTable,VTooltip})
